import Vue from 'vue';

const getDefaultState = () => {
    return {
        products: [],
    };
};

const Products = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        SET_PRODUCTS: async (state, payload) => {
            state.products = payload;
        },

        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },

    },
    actions: {
        fetch: ({ commit }) => {
            return Vue.prototype.$apiService.get('products').then(response => {
                commit('SET_PRODUCTS', response.data);
            }).catch(err => console.log(err.response));
        },

        resetState: ({ commit }) => {
            commit('RESET_STATE');
        },

        fetchLuts: ({ rootState }, product) => {
            return Vue.prototype.$apiService.get('products/luts', {
                params: {
                    block: product
                }
            })
                .then(({ data }) => {
                    return data;
                });
        },
    },
    getters: {},
};

export default Products;
